import React, { Component } from 'react';

import {
    withRouter
} from 'react-router-dom';

import { Layout, Text, Card, TextField, Badge, SkeletonBodyText, Banner, Icon, BlockStack } from '@shopify/polaris';
import {
    CodeMinor
} from '@shopify/polaris-icons';
import './index.css';

import {
    reqGetSiteVerify,
    reqUpdateSiteVerify,

} from '../../../api';
import { connect } from 'react-redux'
import { setPageData } from '../../../redux/actions/getAppPageData';
import Switch from "react-switch";

// 翻译
import Language from '../../../i18n/Language';
import { cloneDeep } from 'lodash';
const t = Language;

class indexClass extends Component {
    state = {
        durationTime: 3000,
        showToastText: '',
        showToast: false,
        showToastIserror: false,
        isOpenState: false,
        loadingSwitch: true,
        loadingPage: true, // 页面loading
        verifyList: [
            {
                title: 'Google Webmaster Tools / Google Search Console',
                about: "about Google Webmaster Site Verifications.",
                desc: [
                    `You can verify your ownership of a site by adding a META tag to the HTML of a specified page.`,
                    "You can find your 'Site verification code' inside the meta tag provided by Google<meta name=\"google-site-verification\" content=\"YOUR_SITE_VERIFICATION_CODE\">"
                ],
                url: 'https://support.google.com/webmasters/answer/9008080?visit_id=638273145927148503-1343427194&rd=1',
                here: 'Read more about Google Webmaster Site Verifications',
                value: '',
                icon: <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M7.14285 2.78727C8.1948 2.78727 9.12986 3.14364 9.87662 3.83091L11.9221 1.82636C10.6818 0.693636 9.07142 0 7.14285 0C4.35064 0 1.94156 1.57182 0.766234 3.86273C0.279221 4.80455 0 5.86727 0 7C0 8.13272 0.279219 9.19545 0.766229 10.1373V10.1436C1.94155 12.4282 4.35064 14 7.14285 14C9.07142 14 10.6883 13.3764 11.8701 12.3073C13.2208 11.0855 14 9.29091 14 7.15909C14 6.66273 13.9545 6.18546 13.8701 5.72727H7.14286V8.43818H10.987C10.8182 9.31 10.3117 10.0482 9.55195 10.5445C8.91558 10.9645 8.10389 11.2191 7.14285 11.2191C5.28571 11.2191 3.70779 9.99091 3.14285 8.33636H3.13437L3.14286 8.33C3 7.91 2.91558 7.46454 2.91558 7C2.91558 6.53545 3 6.08999 3.14286 5.66999C3.7078 4.01545 5.28572 2.78727 7.14285 2.78727Z" fill="#4A4A4A" />
                </svg>
                ,
                tag: 'google_site_verification'
            },
            {
                title: 'Bing Webmaster Tools',
                about: "about Bing Site Verifications.",
                desc: [
                    "You can find your 'Bing verification code' inside the meta tag provided by Bing<meta name=\"msvalidate.01\" content=\"YOUR_SITE_VERIFICATION_CODE\">",
                ],
                url: 'https://www.bing.com/webmasters/help/add-and-verify-site-12184f8b',
                here: 'Read more about Bing Site Verifications',
                value: '',
                icon: <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.25433 17.3615C1.57191 17.3615 0.97183 16.9278 0.725497 16.2565C0.686414 16.1501 0.66658 16.0339 0.66658 15.9114V1.43077C0.66658 1.23052 0.752747 1.04511 0.902914 0.922107C1.14108 0.727107 1.40508 0.624023 1.66633 0.624023C1.98433 0.624023 2.28583 0.778107 2.51508 1.05786C2.61283 1.17702 2.66666 1.32777 2.66666 1.48219V15.0856L10.6606 10.9259L4.31358 8.61127C4.21341 8.57477 4.12358 8.51661 4.05366 8.44311C3.68341 8.05361 3.63275 7.51602 3.92758 7.10536C4.11875 6.83902 4.42575 6.68002 4.74875 6.68002C4.86866 6.68002 4.98775 6.70161 5.10275 6.74411L12.4359 9.45519C13.0225 9.67202 13.4167 10.2379 13.4167 10.8633C13.4167 11.4178 13.113 11.9249 12.6242 12.1866L2.96066 17.1966C2.92091 17.2179 2.88675 17.2339 2.85325 17.2471C2.65958 17.323 2.45808 17.3615 2.25433 17.3615Z" fill="#4A4A4A" />
                </svg>
                ,
                tag: 'ms_validate'
            },
            {
                title: 'Pinterest verification',
                about: "about Pinterest Site Verifications.",
                desc: [
                    "You can find your 'Pinterest verification code' inside the meta tag provided by Pinterest<meta name=\"p:domain_verify\" content=\"YOUR_SITE_VERIFICATION_CODE\">",
                ],
                url: 'https://help.pinterest.com/en/business/article/claim-your-website',
                here: 'Read more about Pinterest Site Verifications',
                value: '',
                icon: <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M0 5.34665C0 2.55983 2.15291 0 6.20797 0C9.46731 0 12 2.18364 12 5.10299C12 8.14806 9.95802 10.5985 7.12471 10.5985C6.17253 10.5985 5.27784 10.1333 4.97177 9.58378C4.97177 9.58378 4.50059 11.2706 4.38604 11.6842C4.17396 12.4513 3.60176 13.4134 3.21802 14C2.99895 13.9362 2.78695 13.8581 2.57504 13.78C2.49333 13.0812 2.41973 12.0124 2.60856 11.2516C2.77912 10.5625 3.71031 6.85983 3.71031 6.85983C3.71031 6.85983 3.42919 6.33042 3.42919 5.5485C3.42919 4.31972 4.1862 3.4029 5.12898 3.4029C5.9308 3.4029 6.31744 3.96904 6.31744 4.64732C6.31744 5.1322 6.10789 5.77012 5.88731 6.44159C5.76286 6.82045 5.6349 7.20999 5.53909 7.58875C5.31761 8.46852 6.00813 9.18586 6.93029 9.18586C8.60008 9.18586 9.88359 7.52994 9.88359 5.14004C9.88359 3.02469 8.26764 1.54548 5.9597 1.54548C3.28681 1.54548 1.71785 3.4311 1.71785 5.37995C1.71785 6.13909 2.02859 6.95329 2.41706 7.39639C2.49367 7.48408 2.50485 7.56054 2.48209 7.64958C2.43892 7.81875 2.36373 8.10601 2.30422 8.33336C2.26559 8.48093 2.23357 8.60326 2.2212 8.65168C2.18038 8.81378 2.08496 8.84743 1.9072 8.76959C0.73353 8.25581 0 6.6427 0 5.34665Z" fill="#303030" />
                </svg>
                ,
                tag: 'domain_verify'
            },
            {
                title: 'Yandex Webmaster',
                about: "about Yandex Webmaster Site Verifications.",
                desc: [
                    "You can find your 'Yandex verification code' inside the meta tag provided by Yandex<meta name=\"yandex-verification\" content=\"YOUR_SITE_VERIFICATION_CODE\">",
                ],
                url: 'https://yandex.com/support/',
                here: 'Read more about Yandex Site Verifications',
                value: '',
                icon: <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.28938 0.5H5.10626C2.96126 0.5 1.25001 2.2 1.25001 5.5C1.25001 7.48 2.02313 8.94 3.59313 9.66L0.663131 15.18C0.567506 15.3606 0.663131 15.5 0.816256 15.5H2.17563C2.29063 15.5 2.36751 15.46 2.40563 15.3606L5.15626 9.875H5.93751L5.93251 15.3606C5.93251 15.4206 5.99001 15.5 6.06626 15.5H7.34688C7.46188 15.5 7.50001 15.44 7.50001 15.3406V0.7C7.50001 0.56 7.42313 0.5 7.28938 0.5ZM5.93751 8.625H5.00001C4.06251 8.625 2.81251 7.9 2.81251 5.5C2.81251 2.99938 3.83188 1.75 5.00001 1.75H5.93751V8.625Z" fill="#4A4A4A" />
                </svg>
                ,
                tag: 'yandex_verification'
            },
            {
                title: 'Norton safe web site verification',
                about: "about Norton safe web Site Verifications.",
                desc: [
                    "You can find your 'Norton verification code' inside the meta tag provided by Norton<meta name=\"norton-safeweb-site-verification\" content=\"YOUR_SITE_VERIFICATION_CODE\">"
                ],
                url: 'https://safeweb.norton.com/help/site-owner',
                here: 'Read more about Norton Site Verifications',
                value: '',
                icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.2583 0.68H18.9225V1.34417H18.2583V0.68ZM18.2583 1.34417H17.0275V2.00833H18.2583V1.34417ZM17.0275 2.00833V3.30333H16.4125V2.00833H17.0275ZM17.0275 3.30333H17.6592V3.935H17.0275V3.30333ZM17.6592 3.30333V2.68H18.3558V3.30333H17.6592ZM17.0275 3.935V5.27917H16.4858V5.80583H15.9108V6.575H15.4167V7.23083H14.785V6.58333H14.1533L14.145 7.23083H14.785V7.91917H14.1533L14.1617 8.67167H13.6192L13.6275 9.30333H13.125L13.1167 10.0158C12.17 11.3783 11.5142 12.8083 10.9225 14.235C10.8475 14.4158 10.82 14.5642 10.7283 14.6717C10.5292 14.905 10.2325 14.9783 9.99083 14.9717C9.53916 14.9592 9.14083 14.7483 8.93083 14.2592C8.2225 12.6175 7.8725 11.4675 5.92666 9.31167C5.61333 8.96417 5.68583 8.52083 5.935 8.38083C6.17333 8.245 6.5075 8.3425 6.88166 8.55083C7.93 9.13417 8.51333 9.73 9.75666 11.3842C10.2092 10.2917 10.9917 8.81417 11.9667 7.21417H12.42V6.58333H12.8492V5.95833H13.4808V4.96333H14.1617L14.1533 5.595H14.785V4.96333H14.1617V4.39667H14.7283V3.935H15.7725V4.58333H16.4125V3.935H17.0275ZM15.7725 3.935V3.30333H16.4125V3.935H15.7725ZM15.7725 3.30333H15.1333V2.69667H15.7725V3.30333ZM17.0275 2.01167H17.6583V2.67667H17.0275V2.01167ZM18.9192 1.34583H19.6017V2.01167H18.9183L18.9192 1.34583ZM13.7892 3.78667V4.405H13.0117V5.44167H12.2342V6.05333C11.3825 5.60678 10.4349 5.37452 9.47333 5.37667C6.18416 5.37667 3.51333 8.03917 3.51333 11.3283C3.51333 14.6167 6.18416 17.2792 9.47333 17.2792C10.2548 17.2793 11.0287 17.1254 11.7507 16.8264C12.4728 16.5274 13.1288 16.0891 13.6814 15.5365C14.2341 14.9838 14.6724 14.3278 14.9714 13.6057C15.2704 12.8837 15.4243 12.1098 15.4242 11.3283C15.4262 10.3603 15.1907 9.40662 14.7383 8.55083H15.3433V7.77333H15.8617V6.99583H16.38V6.34833H16.605C17.6307 7.80619 18.18 9.5458 18.1775 11.3283C18.1775 16.1167 14.2942 20 9.505 20C4.71583 20 0.833328 16.1167 0.833328 11.3283C0.833328 6.54 4.71666 2.65583 9.505 2.65583C11.0633 2.65583 12.525 3.06667 13.7883 3.78667M18.9192 0H19.6017V0.680833H18.9183L18.9192 0Z" fill="#4A4A4A" />
                </svg>
                ,
                tag: 'n_s_site_verification'
            }
        ],  // 验证列表
        beforeVerifyList: {
            google_site_verification: '',
            domain_verify: '',
            ms_validate: '',
            yandex_verification: '',
            n_s_site_verification: '',
        }, // 未更新前
        disOperaState: true,
        isDisabledField: '', // 是否禁用
    }

    componentDidMount() {
        let _page = this.props.page.pageInit;
        // 判断缓存
        if (Boolean(_page.siteVerify)) {
            this.getSiteVerifyData(_page.siteVerify);
        }
        this.getSiteVerifyData();
    }

    // 获取数据
    getSiteVerifyData = async (data = null) => {
        let res = {};
        if (data) {
            res = data;
        } else {
            res = await reqGetSiteVerify();
        }

        if (res.ack) {
            let { verifyList, beforeVerifyList } = this.state;
            let curList = cloneDeep(verifyList);
            curList.forEach(item => {
                item.value = res.data[item.tag];
            })
            let bVerify = cloneDeep(beforeVerifyList);
            Object.keys(bVerify).forEach(item => {
                bVerify[item] = res.data[item];
            })
            this.setState({
                isOpenState: Boolean(res.data.switch),
                verifyList: curList,
                beforeVerifyList: bVerify
            })
            this.props.setSiteVerifyData(res);
        } else {
            this.props.toggleToast(res.msg, true)
        }
        if (res) {
            this.setState({
                loadingPage: false,
            })
            if (!Boolean(data)) {
                this.setState({
                    disOperaState: false,
                    loadingSwitch: false,
                })
            }
        }
    }

    // 开关切换
    handleCheckChange = (e) => {
        this.setState({
            isOpenState: e,
            loadingSwitch: true,
        }, () => {
            let params = {
                params: [
                    {
                        key: 'switch',
                        value: Number(e)
                    }
                ]
            }
            this.updateVerifyData(params, 'switch');
        })
    }

    // 更新数据
    updateVerifyData = async (params, type) => {
        const res = await reqUpdateSiteVerify(params);
        if (res.ack === 1) {
            this.props.toggleToast(t("Success"), false);
            if (type === 'all') {
                let { beforeVerifyList, verifyList } = this.state;
                let bVerify = cloneDeep(beforeVerifyList);
                verifyList.forEach(item => {
                    bVerify[item.tag] = item.value;
                })
                this.setState({
                    beforeVerifyList: bVerify
                })
                this.props.setShowSaveBarState(false, this);
            }
        } else {
            this.setWarnBanner(res.msg);      
        }

        if (res) {
            this.setState({
                loadingSwitch: false,
                isDisabledField: '',
            }, () => {
                this.props.setSaveState(1, false, 'loading');
            })
            if (type === 'switch') {
                let {isOpenState} = this.state;
                this.setState({
                    isOpenState: !Boolean(res.ack) ? !Boolean(isOpenState) : Boolean(isOpenState),
                })
            }
        }
    }

    // 输入
    handleInputChange = (val, name) => {
        let cList = cloneDeep(this.state.verifyList);
        cList.filter(item => item.title === name)[0]['value'] = val;
        this.setState({
            verifyList: cList
        }, () => {
            this.checkChangeState();
        })
    }

    // 保存
    onChangeVerifyData = () => {
        // 判断是否修改并发起请求
        let { verifyList, beforeVerifyList } = this.state;
        if (verifyList.filter(i => (i.value).indexOf('<meta') > -1).length > 0) {
            this.props.setSaveState(1, false, 'loading');
            this.setWarnBanner("The input field only needs to fill in the value of content");
        } else {
            const compareField = {
                google_site_verification: 'googleSiteVerification',
                domain_verify: 'domainVerify',
                ms_validate: 'msValidate',
                yandex_verification: 'yandexVerification',
                n_s_site_verification: 'nortonSafeWebSiteVerification',
            }
            let valueArr = [];
            verifyList.forEach(item => {
                if(item.value !== beforeVerifyList[item.tag]) {
                    valueArr.push({
                        key: compareField[item.tag],
                        value: item.value
                    })
                }
            })
            let params = {
                params: valueArr
            }
            this.updateVerifyData(params, 'all');
        }
    }

    // 失焦
    onBlurVerifyData = (val, data) => {
        // 判断是否修改并发起请求
        let { beforeVerifyList } = this.state;
        if (val.indexOf('<meta') > -1) {
            this.setWarnBanner("The input field only needs to fill in the value of content");
        } else {
            if (typeof val === "string" && typeof beforeVerifyList[data.tag] === "string") {
                if (val.replace(/\s+/g, "") !== beforeVerifyList[data.tag].replace(/\s+/g, "")) {
                    this.setState({
                        isDisabledField: data.tag
                    }, () => {
                        const compareField = {
                            google_site_verification: 'googleSiteVerification',
                            domain_verify: 'domainVerify',
                            ms_validate: 'msValidate',
                            yandex_verification: 'yandexVerification',
                            n_s_site_verification: 'nortonSafeWebSiteVerification',
                        }
                        let params = {
                            key: compareField[data.tag],
                            value: val
                        }
                        this.updateVerifyData(params, data.tag);
                    })
                }
            }
        }
    }

    // 检查修改状态
    checkChangeState = () => {
        let { beforeVerifyList, verifyList } = this.state;
        let changeNums = 0;
        Object.keys(beforeVerifyList).forEach(bitem => {
            verifyList.forEach(citem => {
                if (bitem === citem.tag && beforeVerifyList[bitem] !== citem.value) {
                    changeNums += 1;
                }
            })
        })
        let isShow = changeNums > 0;
        this.props.setShowSaveBarState(isShow, this);
    }

    // 舍弃修改
    discardVerifyData = () => {
        let { beforeVerifyList, verifyList } = this.state;
        let discardList = cloneDeep(verifyList);
        discardList.forEach(item => {
            item.value = beforeVerifyList[item.tag];
        })
        this.setState({
            verifyList: discardList,
        })
    }

    // 跳转外链
    jumpOutUrl = (url) => {
        window.open(url);
    }

    // 设置提示banner
    setWarnBanner = (msg) => {
        window.scrollTo(0, 0);
        this.setState({
            isShowWarnTip: t(msg),
        })
    }

    //点击联系客服
    handleContactService = () => {
        try {
            window.Willdesk.show()
        } catch (e) {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    render() {
        const {
            state: {
                isOpenState,
                loadingSwitch,
                verifyList,
                loadingPage,
                disOperaState,
                isDisabledField,
                isShowWarnTip,

            }
        } = this;

        // 错误banner
        const warnBannerBox = isShowWarnTip && <div style={{ marginBottom: '1rem' }}>
            <Banner
                title={t(isShowWarnTip)}
                tone="warning"
                onDismiss={() => {
                    this.setState({
                        isShowWarnTip: ''
                    })
                }}
                action={{
                    content: t("contact us"),
                    onAction: this.handleContactService
                }}
            >
            </Banner>
        </div>

        // 开关
        const TopSwitchBlock = <Card>
            <div className='boost_web'>
                <Text variant="headingMd" as="h2">{t("Site verifications status")}</Text>
                {
                    isOpenState ? <Badge tone='success'>{t("On")}</Badge> :
                        <Badge>{t("Off")}</Badge>
                }
                <div>
                    {loadingSwitch && <img className="Loading" src="/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
                    <Switch disabled={disOperaState} onChange={this.handleCheckChange} checked={isOpenState} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
                </div>
            </div>
            <p>{t("The settings below will not be effective unless you enable the Site Verification status.")}</p>
        </Card>

        // 列表
        const CodeListBlock = <div className='verify_list'>
            {
                verifyList.map(item => {
                    return <div key={item.title}>
                        <Card>
                            <BlockStack gap={200}>
                                <div className='flex_layout'>
                                    <span className='flex_layout'>{item.icon}</span>
                                    <Text variant="headingMd" as="h2">{t(item.title)}</Text>
                                </div>
                                <p>
                                    {t("Verification is the process of proving that you own the site that you claim to own.")}
                                    <span className='jump_text' onClick={() => this.jumpOutUrl(item.url)}>&nbsp;{t("Read more")}&nbsp;</span>
                                    {t(item.about)}
                                </p>
                                <div className='text_input_block'>
                                    <TextField
                                        id={`${item.title}`}
                                        label={t("Verification code")}
                                        type="text"
                                        value={item.value}
                                        onChange={this.handleInputChange}
                                        placeholder={t("YOUR_SITE_VERIFICATION_CODE")}
                                        disabled={disOperaState || isDisabledField === item.tag}
                                        // onBlur={() => this.onBlurVerifyData(item.value, item)}
                                        prefix={<Icon source={CodeMinor} tone='base' />}
                                    />
                                    {(disOperaState || isDisabledField === item.tag) && <img className="Loading" src="/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
                                </div>
                            </BlockStack>
                        </Card>
                    </div>
                })
            }
        </div>

        // 骨架屏
        const SkeltonLoading = <div>
            <Layout>
                <Layout.Section>
                    <Card>
                        <SkeletonBodyText />
                    </Card>
                    <div className='verify_list'>
                        <Card>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText lines={2} />
                        </Card>
                        <Card>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText lines={2} />
                        </Card>
                        <Card>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText lines={2} />
                        </Card>
                        <Card>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText lines={2} />
                        </Card>
                        <Card>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText lines={2} />
                        </Card>
                    </div>
                </Layout.Section>
            </Layout>
        </div>;

        // 底部
        // const FooterHelpBox = <FooterTrustHelp />

        // 最终页面
        const pageContent = !loadingPage ? <div className='site_verify'>
            <Layout>
                <Layout.Section>
                    {warnBannerBox}
                    {TopSwitchBlock}
                    {CodeListBlock}
                </Layout.Section>
            </Layout>

            {/* 底部 */}
            {/* {FooterHelpBox} */}
        </div> : SkeltonLoading;


        return pageContent;

    }
}


const mapStateToProps = state => {
    return state
}

const mapDispatchToProps = dispatch => ({
    // 缓存
    setSiteVerifyData(data) {
        dispatch(setPageData(['siteVerify', data]));
    },
})


indexClass = connect(
    mapStateToProps,
    mapDispatchToProps
)(indexClass);

export default withRouter(indexClass);
